import { useEffect } from 'react';
import '../styles/ContactUs.scss';
import ContactUsForm from './ContactUsForm';

function ContactUs(props: { title: string }) {
  useEffect(() => {
    document.title = props.title;
  });
  return (
    <div className="contact-us-page">
      <h1>Let's work<span className="semi-transparent">together</span></h1>
      <ContactUsForm />
    </div>
  );
}

export default ContactUs;
